import { BoundaryDraw } from "components/boundary/draw/boundary-draw";
import { STATIC_DRAW_MODE } from "components/boundary/draw/draw-modes";
import { bbox } from "@turf/turf";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { Ref, useState } from "react";
import { MapRef } from "react-map-gl/maplibre";
import { ClipConfiguration } from "../../models";
import { ClipItem } from "./clip-item";

interface RecentClipsProps {
  onSelect: (clip: ClipConfiguration) => void;
  maxClips: number;
  clips: ClipConfiguration[];
  draw: BoundaryDraw;
  mapRef: Ref<MapRef>;
}

export const RecentClips = (props: RecentClipsProps) => {
  const [selected, setSelected] = useState("");

  const handleSelect = (clip: ClipConfiguration) => {
    setSelected(clip.id);
    props.draw.deleteAll();
    props.draw.changeMode(STATIC_DRAW_MODE);
    if (!props.draw) {
      return;
    }
    if (!clip.geometry || clip.geometry.features.length == 0) {
      return;
    }
    clip.geometry.features.map((f) => {
      props.draw.add(f);
    });

    const [minLng, minLat, maxLng, maxLat] = bbox(clip.geometry);

    //@ts-ignore
    props.mapRef.current?.fitBounds(
      [
        [minLng, minLat],
        [maxLng, maxLat],
      ],
      { padding: 20, duration: 1000 }
    );
  };
  dayjs.extend(utc);

  return (
    <div className="flex flex-col gap-2">
      {props.clips.slice(0, props.maxClips).map((clip: ClipConfiguration) => (
        <ClipItem
          isSelected={selected === clip.id}
          key={clip.id}
          clip={clip}
          onOpen={(clip: ClipConfiguration) => props.onSelect(clip)}
          onSelect={handleSelect}
        />
      ))}
    </div>
  );
};
